import { ADD_ACTIVE_QUIZZES, ADD_POOL_QUIZZES, CLEAR_PREVIOUS_ATTEMPT, RESET_LEARN_STATE, RESET_QUIZ_STATE, SET_NEXT_QUESTION, SET_QUIZ_INDEX, SET_QUIZ_STATUS_AND_START_TIME, START_QUIZ, UPDATE_ACTIVE_QUIZZES, UPDATE_ACTIVE_QUIZ_SUBMISSIONS, UPDATE_QUIZ_INDEX, SET_QUIZ_STATUS, UPDATE_QUIZ_TRACKER, UPDATE_QUIZ_QUESTION_DETAIL } from "../action";
import { AuthPoolQuiz, LearnStateInterface, Quiz } from "./learn.interface";

interface UpdateActiveQuizzesAction {
    type: 'UPDATE_ACTIVE_QUIZZES';
    data: AuthPoolQuiz;
}

// Define other action types
interface OtherAction {
    type: string; // or specific type if you have defined constants for actions
    data?: any; // You can set it to any for other action types
}


// Create a union type for all action types
type Action = UpdateActiveQuizzesAction | OtherAction;

const LearnReducer = (state: LearnStateInterface, action: Action) => {
    switch(action.type) {
        // Handle different actions types
        case ADD_ACTIVE_QUIZZES:
            return {
                ...state,
                activeQuizzes: action.data
            }
        
        case SET_QUIZ_STATUS_AND_START_TIME:
          return {
            ...state,
            ...action.data
          } 
        case SET_QUIZ_STATUS:
          return {
            ...state,
            ...action.data
          }
        case UPDATE_ACTIVE_QUIZZES:

            if (!state.activeQuizzes) {
                return {
                    ...state,
                    activeQuizzes: [action.data]
                };
            }

            const existingPoolIndex = state.activeQuizzes.findIndex((activeQuiz) => {
                return activeQuiz.poolId === action.data.poolId;
            });

            if (existingPoolIndex !== -1) {
                const updatedQuizzes = [...state.activeQuizzes];
                updatedQuizzes[existingPoolIndex].quizzes.push(action.data.quizzes[0]);
                return {
                    ...state,
                    activeQuizzes: updatedQuizzes
                };
            }

            return {
                ...state,
                activeQuizzes: [...state.activeQuizzes, action.data]
            };

        case ADD_POOL_QUIZZES:
            let existingQuizIds = state.quizzes?.map((quiz: Quiz) => {return quiz.id});
            let newQuizzes = action.data.filter((quiz: Quiz) => {
                return existingQuizIds && !existingQuizIds.includes(quiz.id);
            })
            return {
                ...state,
                quizzes: [...(state.quizzes || []), ...newQuizzes ]
            }
        
        case SET_NEXT_QUESTION:
            let hasQuestion = state.currentQuizQuestionsWithDetails.filter((q: any) => {
                return q.quizId === action.data.quizId && q.questionId === action.data.questionId
            })
            if (hasQuestion && hasQuestion.length > 0) return {
                ...state,
                nextQuestion: action.data
            }
            else {
                return {
                    ...state,
                    nextQuestion: action.data,
                    currentQuizQuestionsWithDetails: [...state.currentQuizQuestionsWithDetails, action.data]
                }
            }

        case UPDATE_QUIZ_INDEX:
            return {
                ...state,
                quizIndex: state.quizIndex + 1,
                currentQuizQuestionsWithDetails: [],
                activeQuizSubmissions: [],
                nextQuestion: null,
            }

        case SET_QUIZ_INDEX:
            return {
                ...state,
                quizIndex: action.data,
            }

        case UPDATE_QUIZ_TRACKER:
            return {
                ...state,
                quizTracker: action.data
            }

        case START_QUIZ:
            return {
                ...state,
                liveQuiz: {
                    ...state.liveQuiz,
                    ...action.data,
                }
            }

        case UPDATE_QUIZ_QUESTION_DETAIL:
            const updatedQuestionWithDetails = [...state.currentQuizQuestionsWithDetails, ...action.data].reduce((accumulator, current) => {
                if (!accumulator.some((item: any) => item.questionId === current.questionId)) {
                  accumulator.push(current);
                }
                return accumulator;
            }, []);
            return {
                ...state,
                currentQuizQuestionsWithDetails: updatedQuestionWithDetails
            }

        case UPDATE_ACTIVE_QUIZ_SUBMISSIONS:
            // Start with a copy of the current state's activeQuizSubmissions
            let updatedSubmissions = [...state.activeQuizSubmissions];

            // Iterate over each submission in the action data
            for (let newSubmission of action.data) {
                let found = false;  // This flag will check if we've updated an existing entry

                // Check each submission already in updatedSubmissions
                for (let i = 0; i < updatedSubmissions.length; i++) {
                    if (updatedSubmissions[i].questionId === newSubmission.questionId) {
                        // Found a submission with the same questionId
                        if (updatedSubmissions[i].answerId !== newSubmission.answerId) {
                            // answerId does not match, replace the submission
                            updatedSubmissions[i] = newSubmission;
                        }
                        found = true;
                        break;  // Exit loop since we've handled this new submission
                    }
                }

                // If no existing submission matched the new one, add it
                if (!found) {
                    updatedSubmissions.push(newSubmission);
                }
            }

            // Return the updated state
            return {
                ...state,
                activeQuizSubmissions: updatedSubmissions
            }

        case RESET_LEARN_STATE:
            return {
                ...state,
                nextQuestion: null,
                quizIndex: -1,
                activeQuizSubmissions: [],
                currentQuizQuestionsWithDetails: [],
                quizTracker: null,
            }

        case RESET_QUIZ_STATE:
            // Resets current quiz state
            return {
                ...state,
                nextQuestion: null,
                activeQuizSubmissions: [],
                currentQuizQuestionsWithDetails: [],
                quizTracker: null,
                quizIndex: -1,
            }
        
        case CLEAR_PREVIOUS_ATTEMPT:
            return {
                ...state,
                nextQuestion: null,
                activeQuizSubmissions: [],
                currentQuizQuestionsWithDetails: [],
                quizTracker: null,
            }
    }    
};
  
export default LearnReducer;
  